import React from "react";
import { Link } from "@/components/common/Link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
const services = [{
  title: "Elite Musicians",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1671966/img/musician_stage_performance.png",
  link: "/RosterPage"
}, {
  title: "World-Class Dancers",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1671966/img/contemporary_dance_motion.png",
  link: "/RosterPage"
}, {
  title: "Circus & Acrobats",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1671966/img/circus_performer_aerial.png",
  link: "/RosterPage"
}];
export default function OurSignatureCreations() {
  return <section data-section-id="223301" id="our-elite-roster" className="bg-background text-foreground py-24 px-4 md:px-8 relative overflow-hidden">
      {}
      <div className="container mx-auto max-w-6xl relative z-10">
        <div className="text-center mb-16">
          <h2 className="font-default text-3xl md:text-5xl font-bold tracking-widest uppercase mb-4 text-foreground">
            Our Elite Roster
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg font-default">
            Curating the world's most extraordinary talent for the global stage. Experience the pinnacle of performance art.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, i) => <div key={i} data-index={i} className="group relative flex flex-col overflow-hidden rounded-md bg-card border border-border transition-all duration-500 hover:border-primary hover:shadow-2xl">
              <div className="overflow-hidden">
                <AspectRatio ratio={16 / 9}>
                  <img src={service.image} alt={service.title} className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-110 grayscale hover:grayscale-0" />
                </AspectRatio>
              </div>
              
              <div className="p-8 flex flex-col items-center text-center flex-grow justify-between bg-card relative z-10">
                <h3 className="font-default text-2xl font-semibold mb-6 tracking-wide text-foreground">
                  {service.title}
                </h3>
                
                <Link to={service.link} className="relative inline-flex items-center text-primary font-bold group/link pb-1 text-sm uppercase tracking-widest">
                  View Category
                  <span className="absolute bottom-0 left-1/2 w-0 h-[1px] bg-primary transition-all duration-300 ease-out -translate-x-1/2 group-hover/link:w-full"></span>
                </Link>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}